module.exports = __webpack_public_path__ + "static/img/redPacket.c59cbd78.png";